import React, { FC } from 'react';
import { ChartPercentLegend } from '../../legend/ChartLegend';
import { getPercentPieChartConfig } from '../../getPieChartConfig';
import { LazyReactChart } from '../../LazyReactChart';
import {
  EntityChartBlock,
  EntityChartItem,
} from '../../components/EntityChartComponents';

type Props = {
  sectorsData: Array<number> | null;
  sectorsLabels: Array<string> | null;
};

export const CompanySectorTypologiesChart: FC<Props> = ({
  sectorsData,
  sectorsLabels,
}) => {
  const sectorsBaseH = 278;

  return (
    <EntityChartBlock>
      <EntityChartItem>
        {sectorsData && sectorsLabels && (
          <LazyReactChart
            config={getPercentPieChartConfig({
              data: sectorsData,
              labels: sectorsLabels,
              baseH: sectorsBaseH,
            })}
          />
        )}
      </EntityChartItem>
      {sectorsData && sectorsLabels && (
        <ChartPercentLegend
          data={sectorsData}
          labels={sectorsLabels}
          baseH={sectorsBaseH}
        />
      )}
    </EntityChartBlock>
  );
};
